// utils/keyManager.ts  

import { ensureDeviceIdReady, getDeviceId as _getDeviceId } from "./common/deviceHelpers";
import { getPrivateCryptoKey, getPublicKeyPem } from "./crypto/keyStorageSecure";

export const getPrivateKey = async (): Promise<CryptoKey> => getPrivateCryptoKey();

/** RECOMMENDED: async accessor that guarantees canonical device_id is ready */
export const getDeviceIdAsync = async (): Promise<string> => {
  await ensureDeviceIdReady();
  return _getDeviceId();
};

/** Legacy sync. Only safe AFTER `getDeviceIdAsync()` has run this session. */
export const getDeviceId = (): string => _getDeviceId();

export const getMyPublicKey = async (): Promise<string> => {
  const k = await getPublicKeyPem();
  if (!k) throw new Error("Public key not found. Generate/restore first.");
  return k;
};
